import React from "react";
import { useSelector } from "react-redux";
import { AlertTitle, Snackbar, Typography } from "@mui/material";
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref){
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Message = ({ handleClose }) => {
    const { open, severity, title, msg } = useSelector(state => state.alert);

    return(
        <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={open} autoHideDuration={6000} onClose={handleClose}>
            <Alert onClose={handleClose} severity={severity}>
                <AlertTitle> {title} </AlertTitle>
                <Typography align="center" paragraph><b>{msg}</b></Typography>
            </Alert>
        </Snackbar>
    )
}

export default Message;